import styled from "styled-components";

import { layout } from "/styles";

export const Base = styled.div(layout.flexCenterHorizontal, {
  textAlign: "start",
});
